function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGooglePay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 12,
  fill: "none",
  viewBox: "0 0 32 12"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#google-pay_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M10.358 5.104q0-.511-.091-1.015H5.283V6.01h2.854c-.058.307-.182.6-.363.86a2.4 2.4 0 0 1-.692.656v1.25h1.704c.997-.868 1.572-2.153 1.572-3.672",
  style: {
    fill: "#4285f4",
    fill: "color(display-p3 .2588 .5216 .9569)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M5.284 9.981c1.424 0 2.627-.442 3.502-1.205L7.082 7.528c-.474.305-1.084.477-1.798.477-1.378 0-2.549-.877-2.967-2.06H.562v1.287A5.1 5.1 0 0 0 2.51 9.239a5.5 5.5 0 0 0 2.774.742",
  style: {
    fill: "#34a853",
    fill: "color(display-p3 .2039 .6588 .3255)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC04",
  d: "M2.318 5.946a2.83 2.83 0 0 1 0-1.91V2.75H.563A4.76 4.76 0 0 0 0 4.99c0 .779.193 1.547.563 2.242z",
  style: {
    fill: "#fbbc04",
    fill: "color(display-p3 .9843 .7373 .0157)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5F6368",
  d: "M15.135 5.863V9.38h-1.182V.693h3.133c.374-.008.746.055 1.095.184.348.13.666.322.935.568.267.235.48.52.626.836a2.4 2.4 0 0 1 0 2.005c-.146.316-.359.6-.626.836q-.823.74-2.03.74h-1.951zm0-4.1v3.033h1.982c.314.006.623-.076.888-.236a1.54 1.54 0 0 0 .603-.66c.128-.271.169-.572.117-.865a1.5 1.5 0 0 0-.409-.782l-.032-.03c-.15-.15-.33-.27-.532-.349a1.6 1.6 0 0 0-.637-.112zm7.553 1.48q1.31 0 2.067.66.756.662.757 1.814V9.38h-1.13v-.824h-.051q-.734 1.02-1.953 1.019-1.04 0-1.74-.582a1.9 1.9 0 0 1-.524-.654 1.8 1.8 0 0 1-.176-.802q0-.922.739-1.467.738-.545 1.97-.546 1.053 0 1.733.364v-.256a1.2 1.2 0 0 0-.126-.545 1.3 1.3 0 0 0-.361-.442 1.73 1.73 0 0 0-1.141-.406q-.99 0-1.567.788l-1.039-.62q.857-1.164 2.54-1.164zm-1.53 4.318c0 .142.035.282.103.408a.9.9 0 0 0 .288.319 1.5 1.5 0 0 0 .919.291 1.95 1.95 0 0 0 1.328-.52q.588-.523.587-1.226-.552-.416-1.541-.416-.72 0-1.201.327-.485.333-.485.817zm10.843-4.123L28.056 12h-1.22L28.3 9.004l-2.595-5.566h1.284l1.873 4.27h.026l1.824-4.27z",
  style: {
    fill: "#5f6368",
    fill: "color(display-p3 .3725 .3882 .4078)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M5.284 1.976a2.96 2.96 0 0 1 2.026.748L8.82 1.3A5.25 5.25 0 0 0 5.283 0c-.98 0-1.94.258-2.774.743A5.1 5.1 0 0 0 .563 2.75l1.754 1.287c.418-1.183 1.589-2.06 2.967-2.06",
  style: {
    fill: "#ea4335",
    fill: "color(display-p3 .9176 .2627 .2078)",
    fillOpacity: 1
  }
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "google-pay_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h32v12H0z",
  style: {
    fill: "#fff",
    fillOpacity: 1
  }
}))));
export { SvgGooglePay as ReactComponent };